// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'layers';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.237 4.62 9.528.63a1.164 1.164 0 0 0-1.069 0L.752 4.62a.464.464 0 0 0 0 .827l7.708 3.99a1.164 1.164 0 0 0 1.07 0l7.707-3.99a.465.465 0 0 0 0-.827z' />
    <path d='m.512 9.567 7.948 3.836a1.164 1.164 0 0 0 1.07 0l7.97-3.836' />
    <path d='M.512 13.533 8.46 17.37a1.164 1.164 0 0 0 1.07 0l7.97-3.837' />
  </g>
);

export const viewBox = '0 0 18 18';
